/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { isUndefined } from "lodash";
import systemAlert from "../../utils/systemAlert";

import Modal, { ModalHeader } from "../../components/Modal";
import { ModalBody } from "reactstrap";
import Col from "../../components/ContentLayout/Col";
import Row from "../../components/ContentLayout/Row";
import DataComponent from "../../components/DataComponent";
import Select from "../../components/Select";
import Button from "../../components/Button";

import { viewLoading } from "../../utils/loading";

import { excelUploadFiles } from "../../apis/companies/account";

import semuClientSampleFile from "../../assets/file/semuClientSample.xlsx";
import theZoneClientSampleFile from "../../assets/file/theZoneClientSample.xls";

const ClientOtherFileUpload = ({ open, setOpen, filterSubmit }) => {

  const [isUpdate, setIsUpdate] = useState(1);

  const uploadExcelFile = (e, type) => {
    e.preventDefault();

    const file = e.target.files[0];
    if (isUndefined(file)) return;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("isUpdate", isUpdate);

    //console.log("uploadExcelFile: ", formData)

    viewLoading("거래처 등록중 입니다.");
    excelUploadFiles(type, formData)
      .then((res) => {
        filterSubmit();
        systemAlert('거래처 등록되었습니다.');
      })
      .finally(() => {
        viewLoading(false);
      });
  };

  const excelButtons = [
    {
      color: "text",
      size: "sm",
      type: 'button',
      label: (
        <>
          세무사랑 거래처 샘플 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const a = document.createElement("a");
        a.href = semuClientSampleFile;
        a.style.display = "none";
        a.download = "semuClientSampleFile";
        document.body.appendChild(a);
        a.click();
      },
    },
    {
      label: "세무사랑 거래처 엑셀 업로드",
      color: "gray-line",
      size: "sm",
      key: "semu",
      type: "excelfile",
      onChange: (e) => uploadExcelFile(e, 'semu'),
    },
    {
      color: "text",
      size: "sm",
      type: 'button',
      label: (
        <>
          더존 거래처 샘플 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const a = document.createElement("a");
        a.href = theZoneClientSampleFile;
        a.style.display = "none";
        a.download = "theZoneClientSampleFile";
        document.body.appendChild(a);
        a.click();
      },
    },
    {
      label: "더존 거래처 엑셀 업로드",
      color: "gray-line",
      size: "sm",
      key: "theZone",
      type: "excelfile",
      onChange: (e) => uploadExcelFile(e, 'theZone'),
    },
  ];

  const cancel = () => {
    setOpen(false);
  };

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <ModalHeader>타솔루션 엑셀 업로드</ModalHeader>
      <ModalBody>
        <Row>
          <Col sm={6} style={{ textAlign: 'center' }}></Col>
          <Col sm={6} style={{ textAlign: 'center' }}>
            <DataComponent field={{ ...excelButtons[4] }} />
          </Col>
        </Row>
        <Row>
          <Col sm={12} style={{ height: 30 }}></Col>
        </Row>
        <Row>
          <Col sm={6} style={{ textAlign: 'center' }}>
            <label>* 기존 거래처 정보</label>
          </Col>
          <Col sm={6} style={{ textAlign: 'center' }}>
            <Select
              value={isUpdate}
              onChange={(e) => setIsUpdate(e.target.value)}
              list={[
                { label: "새로운 데이터 업데이트", value: 1 },
                { label: "기존 데이터 유지", value: 2 },
              ]}
            ></Select>
          </Col>
        </Row>
        <Row>
          <Col sm={12} style={{ height: 40 }}><hr /></Col>
        </Row>
        <Row>
          <Col style={{ textAlign: 'center', }}>
            <DataComponent field={{ ...excelButtons[1] }} />
            <DataComponent field={{ ...excelButtons[0] }} />

          </Col>
          <Col style={{ textAlign: 'center', }}>
            <DataComponent field={{ ...excelButtons[3] }} />
            <DataComponent field={{ ...excelButtons[2] }} />
          </Col>
        </Row>
      </ModalBody>
      <div className="select-client-info">
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            //size="lg"
            label="닫기"
            color="gray-line"
            action={cancel}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ClientOtherFileUpload;
